module.exports = __webpack_public_path__ + "img/logo.e7fb0df0.png";